<template>
  <div class="p-4 text-center w-full">
    <h1>Survey complete!</h1>
    <div class="font-weight-thin my-2 display-2">Do you want to submit your survey now?</div>
    <div class="py-8">
      <button class="mx-2 rounded px-8 py-2 uppercase tracking-wide font-semibold" @click="backQuestion" type="button" :style="{color: brandColor}">Go Back</button>
      <button class="mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold " id="finish-btn" @click="submitSurvey" type="button" :style="{backgroundColor: brandColor}">Submit</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'submit',
  props: ['brandColor'],
  created () {
    console.log(this.$route.params)
    if (localStorage.getItem('surveyType') === 'company' && this.getObj('company')) {
      this.img = this.getObj('company').logo
    }
  },
  data () {
    return {
      img: ''
    }
  },
  methods: {
    getObj (name) {
      let obj = localStorage.getItem(name)
      return JSON.parse(obj)
    },
    backQuestion () {
      let param = {qno: 1}
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = { link: this.$route.params.link, qno: 1 }
      }
      this.$router.push({name: 'question', params: param})
    },
    submitSurvey () {
      document.getElementById('finish-btn').disabled = true
      let param = 'generic'
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = this.$route.params.link
      }
      axios.post(`${process.env.APP_PATH}/company/` + param, {
        data: this.getObj('user-data'),
        userDetails: this.getObj('userDetails'),
        surveyType: localStorage.getItem('surveyType')
      })
        .then(response => {
          // JSON responses are automatically parsed.
          // console.log('', response.data)
          localStorage.setItem('surveySubmit', true)
          let param = {}
          if (localStorage.getItem('surveyType') !== 'generic') {
            param = { link: this.$route.params.link, qno: 1 }
          }
          if (response.data) {
            if (localStorage.getItem('surveyType') === 'customer') {
              this.$router.push({name: 'customerfinal', params: param})
            } else {
              this.$router.push({name: 'final', params: param})
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>

<style>
.btn-class{
 display: inline-block;
 border:1px solid #c9ae34;
 color: #705D07;
 border-radius: 3px 3px 3px 3px;
 -webkit-border-radius: 3px 3px 3px 3px;
 -moz-border-radius: 3px 3px 3px 3px;
 font-family: Verdana;
 width: auto;
 height: auto;
 font-size: 16px;
 padding: 8px 36px;
 box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 -moz-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 -webkit-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 text-shadow: 0 1px 0 #fff;
 background-image: linear-gradient(to top, #fce374, #fcdf5b);
 background-color: #fce374;
}
.btn-class:hover, .btn-class:active{
 border:1px solid #967d09;
 color: #705D07;
 box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 -moz-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 -webkit-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 background-color: #fcdf5b;
}
</style>



// WEBPACK FOOTER //
// src/components/Submit.vue